import React from 'react';
const TabActionButton = ({
  tooltipText = '',
  buttonCss = '',
  buttonColor = '',
  OnActionButtonClick = '',
  items = '',
  apiService = '',
}) => {
  return (
    <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
      <div className='tootip_box'> {tooltipText} </div>
      <i
        onClick={() => OnActionButtonClick(apiService, items)}
        className={buttonCss}
        style={{ color: buttonColor }}
      >
        {' '}
      </i>
    </span>
  );
};
export default TabActionButton;



// WEBPACK FOOTER //
// ./src/views/ESG/Dashboard/TabActionButton.jsx